export default "__VITE_ASSET__BJYBICUX__"